import { OperationTypeNode } from "graphql";
import extractRootResolver from "./extractRootResolver";
const ONLINE_PREFERRED_QUERIES = [
    'ep_communityList',
    'ep_examLevelList',
    'ep_communityDetails',
    'ep_examLevelDetails',
];
const ONLINE_PREFERRED_OP_NAMES = [
    'EP_QPAuthor',
    'EP_QuestionAnswerContributors',
];
export default function isOnlinePreferredQueries(operation) {
    if (ONLINE_PREFERRED_OP_NAMES.includes(operation.operationName))
        return true;
    const rootResolver = extractRootResolver(operation);
    if (!rootResolver)
        return false;
    return rootResolver.operationType === OperationTypeNode.QUERY
        ? ONLINE_PREFERRED_QUERIES.includes(rootResolver.operationName)
        : false;
}
